import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import { apiFetch, API } from "../services/api";
import ChallengeShopLottery from "./ChallengeShopLottery";

// Page « Boutique & loterie » (barre de navigation, famille Communauté) : achats à valider, tirages
// et paniers 1 minute des challenges en mode boutique, sans passer par la liste des challenges.
export class ChallengeShopPage extends Component {
    state = { challenges: null, selected: "", error: null };

    componentDidMount() {
        apiFetch(API.back + '/challenges', { method: 'GET' })
            .then(res => res.json())
            .then(list => {
                const shops = (Array.isArray(list) ? list : []).filter(c => c.mechanics === "shop");
                const running = shops.find(c => c.status === "running") || shops[0];
                this.setState({ challenges: shops, selected: running ? running.id : "" });
            })
            .catch(() => this.setState({ error: "Erreur lors de la récupération des challenges" }));
    }

    render() {
        const { challenges, selected, error } = this.state;
        const current = (challenges || []).find(c => c.id === selected);
        return (
            <div style={{ padding: 16 }}>
                <h3>Boutique &amp; loterie</h3>
                {error ? <p style={{ color: "#c0392b" }}>{error}</p> : null}
                {!challenges ? <p>Chargement ...</p> : !challenges.length ? <p className="text-muted">Aucun challenge en mode boutique (onglet « Général » d'un challenge › Mécanique).</p> : (
                    <>
                        <Form.Group style={{ maxWidth: 420 }}>
                            <Form.Label>Challenge :</Form.Label>
                            <Form.Control as="select" custom value={selected} onChange={(e) => this.setState({ selected: e.target.value })}>
                                {challenges.map(c => <option key={c.id} value={c.id}>{c.name} ({c.status})</option>)}
                            </Form.Control>
                        </Form.Group>
                        {current ? <ChallengeShopLottery key={current.id} inline challenge={current} /> : null}
                    </>
                )}
            </div>
        );
    }
}

export default ChallengeShopPage;
